// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__2pJjb","controlTag":"styles_controlTag__3-FM5"};